import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _get from 'lodash/get'
import { EMAIL_SIGNUP_INVITE_FRIEND } from '../../../services/email-signup/index'
import CtaDevices from '../../CtaDevices/index'
import PlanCardGrid from '../../PlanCardGrid/index'
import TrustPilot from '../../TrustPilot/index'
import DiscoverGaia from '../../DiscoverGaia/index'
import InviteFriendJumbotron from '../InviteFriendJumbotron/index'
import WatchTransformBelong from '../WatchTransformBelong/index'
import InviteFriend8kGrid from '../InviteFriend8kGrid/index'
import InviteFriendPricingInfo from '../InviteFriendPricingInfo/InviteFriendPricingInfo'
import { get as getConfig } from '../../../config/index'
import { FR } from '../../../services/languages/constants'
import { getPrimary } from '../../../services/languages/index'

function InviteFriendPage ({
  history,
  auth,
  userLanguage,
}) {
  const isAnonymous = !auth.get('jwt')
  const currentLang = getPrimary(userLanguage)
  const config = getConfig()
  const zuoraOutage = _get(config, ['features', 'zuoraOutage'])

  return (
    <section className="invite-friend">
      <div className="invite-friend__container">
        <header className="invite-friend__jumbotron-section invite-friend__header">
          <InviteFriendJumbotron />
        </header>
        <div className="invite-friend__watch-transform-belong">
          <WatchTransformBelong />
        </div>
        <div className="invite-friend__grid">
          <InviteFriend8kGrid />
        </div>
        <div className="invite-friend__trust-pilot">
          <TrustPilot typeTwoColumn />
        </div>
        {
          isAnonymous
            ? <div className="invite-friend__dicover-gaia">
                <DiscoverGaia formName={EMAIL_SIGNUP_INVITE_FRIEND} uiLocation={'Invite Page'} />
              </div>
            : null
        }
        {
          currentLang === FR
            ? null
            : <div className="invite-friend__devices">
                <CtaDevices />
              </div>
        }
        {
          isAnonymous && !zuoraOutage
            ? <div className="invite-friend__plan-grid">
                <PlanCardGrid history={history} />
              </div>
            : null
        }
        {
          isAnonymous
            ? <InviteFriendPricingInfo />
            : null
        }
      </div>
    </section>
  )
}

InviteFriendPage.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  history: PropTypes.object.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default connectRedux(({
  auth,
  user,
}) => ({
  auth,
  userLanguage: user.getIn(['data', 'language']),
  user,
}))(InviteFriendPage)
